export interface Testimonial {
  quote: string;
  author: string;
  location: string;
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Llevaba dos temporadas dando clases sin saber si lo estaba haciendo bien. Con este manual por primera vez siento que hay un hilo conductor real en mis sesiones.',
    author: 'Sergio B.',
    location: 'Valencia'
  },
  {
    quote:
      'El Programador 12 Meses es lo que hace que todo encaje. Ahora sigo el calendario y los alumnos progresan de forma visible cada semana.',
    author: 'Tomás V.',
    location: 'Alicante'
  }
];
